// extracted by mini-css-extract-plugin
export default {"customTabs":"custom-tabs_customTabs__BinWf","wrapper":"custom-tabs_wrapper__m7qJW","tabs":"custom-tabs_tabs__niMmw"};